import React, { useEffect, useState } from 'react'
import { useQuery } from '../../../utils/hooks/query'
import { OrdersRequest, useOrders } from '../../../services/api/orders'
import { defaultPagination } from '../../../services/api/client/types'
import { View } from './View'

export const Container: React.FunctionComponent = () => {
  const query = useQuery()
  const [getOrders, { isLoading, response }] = useOrders()
  const [request, setRequest] = useState<OrdersRequest>({
    companyId: query.get('company'),
    ...defaultPagination,
  })

  useEffect(() => {
    getOrders(request)
  }, [getOrders, request])

  const onPaginationChange = (page: number, perPage?: number) => {
    setRequest({
      companyId: request.companyId,
      page: page,
      perPage: perPage || request.perPage,
    })
  }

  return (
    <View
      data={response?.data}
      meta={response?.meta}
      isLoading={isLoading}
      onPaginationChange={onPaginationChange}
    />
  )
}
